var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bet-component" },
    [
      _c("div", { staticClass: "action-buttons" }, [
        _c(
          "button",
          { staticClass: "action-btn", on: { click: _vm.toggleInventory } },
          [_vm._m(0)]
        ),
        _c(
          "button",
          { staticClass: "action-btn", on: { click: _vm.toggleMarket } },
          [_vm._m(1)]
        ),
      ]),
      _c("div", { ref: "indicatorContainer", staticClass: "items-wrapper" }, [
        _c(
          "div",
          {
            ref: "scrollContainer",
            staticClass: "scroll-container",
            on: { scroll: _vm.onScroll },
          },
          [
            _vm.isLoading
              ? [
                  _c("preload-rect", {
                    staticClass: "preload-rect-item",
                    attrs: { background: "rgba(107,108,125,0.14)" },
                  }),
                  _c("preload-rect", {
                    staticClass: "preload-rect-item",
                    attrs: { background: "rgba(107,108,125,0.14)" },
                  }),
                  _c("preload-rect", {
                    staticClass: "preload-rect-item",
                    attrs: { background: "rgba(107,108,125,0.14)" },
                  }),
                ]
              : _vm.isMarketOpened || !_vm.hasItems
              ? [
                  _c("buy-skin", {
                    staticClass: "buy-skin-item",
                    attrs: { "chicken-road": true, "slot-index": 0 },
                  }),
                  _c("buy-skin", {
                    staticClass: "buy-skin-item",
                    attrs: { "chicken-road": true, "slot-index": 1 },
                  }),
                  _c("buy-skin", {
                    staticClass: "buy-skin-item",
                    attrs: { "chicken-road": true, "slot-index": 2 },
                  }),
                  _vm.isLg
                    ? _c("buy-skin", {
                        staticClass: "buy-skin-item",
                        attrs: { "chicken-road": true, "slot-index": 3 },
                      })
                    : _vm._e(),
                ]
              : _vm.hasItems
              ? [
                  _vm._l(_vm.sortedInventory, function (invItem) {
                    return [
                      invItem && invItem.item
                        ? _c(
                            "button",
                            {
                              key: invItem.id,
                              staticClass: "inv-item-card",
                              class: {
                                "is-selected": _vm.isItemSelected(invItem),
                                "is-disabled": _vm.isItemDisabled(invItem),
                              },
                              attrs: { disabled: _vm.isItemDisabled(invItem) },
                              on: {
                                click: function ($event) {
                                  _vm.toggleSelectedInvItem(
                                    invItem,
                                    !_vm.isItemSelected(invItem)
                                  )
                                },
                              },
                            },
                            [
                              _c("img", {
                                staticClass: "item-img",
                                attrs: {
                                  loading: "lazy",
                                  src: _vm.getItemImageUrl(
                                    invItem.item.id,
                                    "medium"
                                  ),
                                  alt: invItem.item.marketName,
                                },
                              }),
                              _c("div", { staticClass: "price-box" }, [
                                _c("i", {
                                  staticClass: "icon icon_coin-c coin-icon",
                                }),
                                _c("span", { staticClass: "price-text" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        invItem.priceUsd ||
                                          invItem.item.priceUsd
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]),
                              _vm.isItemSelected(invItem)
                                ? _c(
                                    "div",
                                    { staticClass: "border-animation" },
                                    [
                                      _c("div", {
                                        staticClass: "selected-border",
                                      }),
                                      _vm._m(2, true),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                    ]
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm.hasItems && _vm.hasScroll
          ? _c("div", {
              ref: "scrollIndicator",
              staticClass: "scroll-indicator",
              style: { left: _vm.scrollIndicatorPosition + "px" },
            })
          : _vm._e(),
      ]),
      _vm.isInventoryOpened
        ? _c("inventory", { on: { close: _vm.toggleInventory } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "action-btn-inner" }, [
      _c("span", { staticClass: "action-btn-text" }, [_vm._v("ИНВЕНТАРЬ")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "action-btn-inner" }, [
      _c("span", { staticClass: "action-btn-text" }, [_vm._v("МАРКЕТ")]),
      _c("i", { staticClass: "icon_new icon_cart cart-icon" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "check-icon-wrapper" }, [
      _c("i", { staticClass: "icon_new icon_check check-icon" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }